import React, { useState } from 'react';
import {
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Text,
    Box,
    Flex
  } from '@chakra-ui/react';
import ReactCountryFlag from "react-country-flag"
import HeaderAvatar from '../components/header/Avatar';
import { countries } from '../utilities/dummy';
import CustomNotification from '../components/activity';
import { DashboardHeaderProps } from '../types/ui';

export default function DashboardHeader({ isOuterDashboard, currentPage }: DashboardHeaderProps) {
    const [country, setCountry] = useState({ id: "NG", name: "Nigeria" });  

    function handleCountryChange(country: { id: string; name: string }) {
        setCountry((prevState) => ({ ...prevState, ...country }))
    }

    return (
        <div className={`header--contents mr--10 ${isOuterDashboard ? 'justify-content-end ' : ''}`}>
            {!isOuterDashboard ? (
                <Flex justifyContent={'space-between'} alignItems='center' width={'full'}>
                    <Box>
                        <Text fontSize={'xl'} fontWeight='semibold' color={'gray.700'} textTransform='capitalize'>{currentPage}</Text>
                    </Box>
                    <Flex alignItems='center'>
                        <Menu>
                            <MenuButton className='country' as={Button}> 
                                <ReactCountryFlag
                                    className="emojiFlag"
                                    countryCode={country.id}
                                    style={{
                                        fontSize: '20px',
                                        lineHeight: '20px',
                                    }}
                                />
                            </MenuButton>
                            <MenuList>
                                {countries.map((c) => (
                                    <MenuItem key={c.id} onClick={() => handleCountryChange(c)}>
                                        <ReactCountryFlag
                                            className="mr--5"
                                            countryCode={c.id}
                                            style={{
                                                fontSize: '16px',
                                                lineHeight: '16px',
                                            }}
                                        />
                                        <Text fontSize='sm' color='gray.500'>{c.name}</Text>
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </Menu>
                        <CustomNotification />
                        <HeaderAvatar fullName='The Deep Company' email='thedeepcompany@com' />
                    </Flex>
                </Flex>
            ): (
                <HeaderAvatar fullName='The Deep Company' email='thedeepcompany@com' />
            )}
        </div>
    )
}